import { ActionIcon, type ActionIconProps, Tooltip } from "@mantine/core";
import { createLink, type LinkComponent } from "@tanstack/react-router";
import * as React from "react";
import { globalConfig } from "~/consts/config";

interface NavIconTSRProps extends ActionIconProps {
  // Add any additional props you want to pass to the NavLink
  href: string;
  label: string;
  icon: React.ReactNode;
}

const NavIconComponent = React.forwardRef<HTMLAnchorElement, NavIconTSRProps>((props, ref) => {
  return (
    <Tooltip label={props.label} position="right" withArrow>
      <ActionIcon component="a" ref={ref} variant="transparent" {...props} size={32} color="dark">
        {props.icon}
      </ActionIcon>
    </Tooltip>
  );
});

const CreatedLinkComponent = createLink(NavIconComponent);

export const NavIcon: LinkComponent<typeof NavIconComponent> = (props) => {
  return <CreatedLinkComponent preload={globalConfig.preloadStrategy} {...props} />;
};
